
export const isActiveInternet=()=>{
    let isOnline=navigator.onLine
    console.log('is Active Internet',isOnline)
    return isOnline
}

